export let openAnotherMailbox = "h_UYzc";
export default {openAnotherMailbox};